export default __webpack_public_path__ + "assets/images/pessoabf01a8c4da461891fb09b43383255e76.png";